window._EndpointConfig = (function() {

    "use strict";
    // Stage detection regular expressions.
    var orgPlaceholder = '{org-name}',
        prefixPlahceholder = '{app-prefix}',
        regionPlaceholder = '{region-name}',
        CF_REGEX = '.+\.awsapps\.(com|net)/{app-prefix}.*',
        ZOCALO_REGEX = new RegExp(CF_REGEX.replace(prefixPlahceholder, '(workdocs|workdocs-beta|workdocs-flight1|workdocs-flight2|workdocs-flight3|workdocs-flight4|workdocs-flight5)'), 'i'),
        TLD_REGEX = new RegExp(CF_REGEX.replace(prefixPlahceholder, ''), 'i'),

        AMAZON_ORG_NAME = 'amazon',

        // Fields
        CF_ALIAS = 'cfAlias',
        REGEX = 'regex',
        CLIENT_ID = 'clientId',
        LOGIN_ENDPOINT = 'loginEndpoint',
        LOGIN_V2_ENDPOINT = 'loginV2Endpoint',
        SERVICE_ENDPOINT = 'serviceEndpoint',
        WD_SERVICE_ENDPOINT = 'wdServiceEndpoint',
        CLIENT_ENDPOINT = 'clientEndpoint',
        PRINT_CONTAINER_URL = "printContainerUrl",
        WOPI_SERVICE_ENDPOINT = "wopiServiceEndpoint",
        COLLAB_SERVICE_ENDPOINT = "wdCollabServiceEndpoint",
        HANCOM_ENDPOINT = "hancomEndpoint";

    var TEST = {

        // default test fields (dev)
        cfAlias: 'gba',
        regex: new RegExp('(localhost|127\.0\.0\.1|.*\.desktop\.amazon\.com|.*\.aka\.corp\.amazon\.com)', 'i'),
        clientId: '52c3dfe68db8865f',
        loginEndpoint: 'https://warpspeed.us-east-1.aws.amazon.com/',
        loginV2Endpoint: 'https://{org-name}.awsapps.com/gba/loginv2-a/index.html#/checkAuth',
        wopiServiceEndpoint: 'https://workdocs-web-service-alpha.workdocs.us-west-2.amazonaws.com',
        wdCollabServiceEndpoint:'https://workdocs-web-service-alpha.workdocs.us-west-2.amazonaws.com/',
        hancomEndpoint:'https://dev.wd.thinkfree.com/cloud-office/api/alpha/',

        serviceEndpoint: 'https://zocalo-alpha.us-east-1.amazonaws.com/gb/api/v1/',
        wdServiceEndpoint: 'https://zocalo-alpha.us-east-1.amazonaws.com/api/v1/',

        // serviceEndpoint: 'https://sainara.aka.corp.amazon.com:4231/gb/api/v1/',
        // wdServiceEndpoint: 'https://sainara.aka.corp.amazon.com:4231/api/v1/',


        // test stages
        stages: {
            dev: {
                clientId: '52c3dfe68db8865f'
            },
            alpha: {
                regex: new RegExp(CF_REGEX.replace(prefixPlahceholder, 'gba'), 'i'),
                clientId: 'fdf8b2c5563ee2c3',
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-alpha/gba/pdfjs/printContainer.html',
                loginEndpoint: 'https://{org-name}.awsapps.com/login/'
            },
            beta: {
                cfAlias: 'gbb',
                regex: new RegExp(CF_REGEX.replace(prefixPlahceholder, 'gbb'), 'i'),
                clientId: '6a7ec7f67dca3516',
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-beta/gbinternal/pdfjs/printContainer.html',
                loginEndpoint: 'https://{org-name}.awsapps.com/login/',
                loginV2Endpoint: 'https://{org-name}.awsapps.com/gbb/loginv2-b/index.html#/checkAuth',
                serviceEndpoint: 'https://aws-gb-docs-beta.iad.proxy.amazon.com/gb/api/v1/',
                wdServiceEndpoint: 'https://aws-gb-docs-beta.iad.proxy.amazon.com/api/v1/',
                clientEndpoint: 'https://gb-beta-common.s3.amazonaws.com/'
            },
            gamma: {
                cfAlias: 'gbinternal',
                regex: new RegExp(CF_REGEX.replace(prefixPlahceholder, 'gbinternal'), 'i'),
                clientId: '319a7b3bee52b332',
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-gamma/gbinternal/pdfjs/printContainer.html',
                loginEndpoint: 'https://{org-name}.awsapps.com/login/',
                loginV2Endpoint: 'https://{org-name}.awsapps.com/gbinternal/loginv2-internal/index.html#/checkAuth',
                serviceEndpoint: 'https://zocalo-gamma.us-east-1.amazonaws.com/gb/api/v1/',
                wdServiceEndpoint: 'https://zocalo-gamma.us-east-1.amazonaws.com/api/v1/',
                clientEndpoint: 'https://gb-gamma-common.s3.amazonaws.com/',
                wopiServiceEndpoint: 'https://wopi-service-gamma.workdocs.us-west-2.amazonaws.com',
                wdCollabServiceEndpoint:'https://wopi-service-gamma.workdocs.us-west-2.amazonaws.com',
                hancomEndpoint:'https://dev.wd.thinkfree.com/cloud-office/api/gamma/',
            }
        }
    };

    var PROD = {

        // default PROD fields (us-west-2)
        cfAlias: 'workdocs',
        regex: ZOCALO_REGEX,
        clientId: '55d35d491787e632',
        loginEndpoint: 'https://{org-name}.awsapps.com/login/',
        serviceEndpoint: 'https://zocalo.{region-name}.amazonaws.com/gb/api/v1/',
        wdServiceEndpoint: 'https://zocalo.{region-name}.amazonaws.com/api/v1/',
        clientEndpoint: 'https://gb-prod-common.s3.amazonaws.com/',
        loginV2Endpoint: 'https://{org-name}.awsapps.com/workdocs/loginv2/index.html#/checkAuth',

        // PROD stages
        // The only unique field for current prod regions is the client ID.
        // If a new region has new unique fields, add it as an object and the object's values will
        // override the defaults.
        // E.g.
        // 'new-region-key' : {
        //      cfAlias: 'workdocs',
        //      clientId: 'galaxy-client-id-for-my-region',
        //      etc...
        // }
        // NOTE: Before deciding to add a new loginEndpoint or serviceEndpoint, take a look at
        // the logic in the getOath2Endpoint() and getServiceEndpoint() functions, respectively.
        stages: {
            // IAD
            'us-east-1': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-us-east-1/workdocs/pdfjs/printContainer.html',
                clientId: '06f4bdef20da505e',
                wopiServiceEndpoint: 'https://wopi-service.workdocs.us-east-1.amazonaws.com',
                wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.us-east-1.amazonaws.com',
                hancomEndpoint:'https://virginia.wd.thinkfree.com/cloud-office/api/workdocs/'
            },
            // PDX
            'us-west-2': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-us-west-2/workdocs/pdfjs/printContainer.html',
                clientId: '55d35d491787e632',
                wopiServiceEndpoint: 'https://wopi-service.workdocs.us-west-2.amazonaws.com',
                wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.us-west-2.amazonaws.com',
                hancomEndpoint:'https://oregon.wd.thinkfree.com/cloud-office/api/workdocs/',
            },
            // DUB
            'eu-west-1': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-eu-west-1/workdocs/pdfjs/printContainer.html',
                clientId: '251b5b0609d87b7e',
                wopiServiceEndpoint: 'https://wopi-service.workdocs.eu-west-1.amazonaws.com',
                wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.eu-west-1.amazonaws.com',
                hancomEndpoint:'https://virginia.wd.thinkfree.com/cloud-office/api/workdocseuwest1/',
            },
            // NRT
            'ap-northeast-1': {
              printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-ap-northeast-1/workdocs/pdfjs/printContainer.html',
              clientId: '317f529451f1bfa3',
              wopiServiceEndpoint: 'https://wopi-service.workdocs.ap-northeast-1.amazonaws.com',
              wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.ap-northeast-1.amazonaws.com',
              hancomEndpoint:'https://tokyo.wd.thinkfree.com/cloud-office/api/workdocs/',
            },
            // SYD
            'ap-southeast-2': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-ap-southeast-2/workdocs/pdfjs/printContainer.html',
                clientId: '2da73c619b02cbac',
                wopiServiceEndpoint: 'https://wopi-service.workdocs.ap-southeast-2.amazonaws.com',
                wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.ap-southeast-2.amazonaws.com',
                hancomEndpoint:'https://tokyo.wd.thinkfree.com/cloud-office/api/workdocsapsoutheast2/',
            },

            // FRA
            'eu-central-1': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-eu-central-1/workdocs/pdfjs/printContainer.html',
                clientId: '57ffafbf8f4734ac'
            },

            // SIN
            'ap-southeast-1': {
                printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-ap-southeast-1/workdocs/pdfjs/printContainer.html',
                clientId: 'b79f015143e9e5c6',
                wopiServiceEndpoint: 'https://wopi-service.workdocs.ap-southeast-1.amazonaws.com',
                wdCollabServiceEndpoint:'https://wdcollaboration.workdocs.ap-southeast-1.amazonaws.com',
                hancomEndpoint:'https://tokyo.wd.thinkfree.com/cloud-office/api/workdocsapsoutheast1/',
            }
        }
    };

    var PROD_FLIGHTS = ['beta','flight1', 'flight2', 'flight3', 'flight4', 'flight5', 'flight6', 'flight7', 'flight8', 'flight9', 'flight10'];
    PROD_FLIGHTS.forEach(function(flight) {
        var flightNumber = flight === 'beta' ? 0 : parseInt(flight.substr(6));

        //Prod PDX flights : We use the same client Id because they are in the same regions
        PROD.stages['us-west-2-prod-' + flight] = {
            cfAlias: 'workdocs-' + flight,
            clientId: '55d35d491787e632',
            printContainerUrl : 'https://s3.amazonaws.com/gb-website-prod-us-west-2/workdocs-' + flight + '/pdfjs/printContainer.html',
            serviceEndpoint: 'https://zocalo.us-west-2.amazonaws.com/gb/api/v1/',
            wdServiceEndpoint: 'https://zocalo.us-west-2.amazonaws.com/api/v1/',
            wopiServiceEndpoint: 'https://' + (flightNumber <= 4 ? 'workdocs-web-service-alpha' : 'wopi-service-gamma') + '.workdocs.us-west-2.amazonaws.com',
            wdCollabServiceEndpoint: 'https://wdcollaboration.workdocs.us-west-2.amazonaws.com',
            hancomEndpoint: (flightNumber == 6) ? 'https://stg-new.wd.thinkfree.com/cloud-office/api/workdocs3/' : (flightNumber == 2) ? 'https://us-west-2.wd.thinkfree.com/cloud-office/api/workdocs/' : 'https://oregon.wd.thinkfree.com/cloud-office/api/workdocs/',
        };

        // beta site should point to the same wopi service endpoint as prod PDX.
        PROD.stages['us-west-2-prod-beta'].wopiServiceEndpoint = 'https://wopi-service.workdocs.us-west-2.amazonaws.com';
        PROD.stages['us-west-2-prod-beta'].wdCollabServiceEndpoint = 'https://wdcollaboration.workdocs.us-west-2.amazonaws.com';
        PROD.stages['us-west-2-prod-beta'].hancomEndpoint = 'https://oregon.wd.thinkfree.com/cloud-office/api/workdocs/';
    });

    var CALLBACK_PATH = '/oauth2callback',
        DEFAULT_DEV_ORG = 'gb-engg-alpha-20131219',
        DEV_ENVIRONMENT_PREFIXES = [
            'https://localhost:8000'
        ],
        METRICS_REGION_WHITELIST = [
            'us-east-1',
            'us-west-2',
            'eu-west-1',
            'ap-northeast-1',
            'ap-southeast-1',
            'ap-southeast-2'
        ];

    PROD_FLIGHTS.forEach(function(flight) {
        METRICS_REGION_WHITELIST.push('us-west-2-prod-' + flight);
    });
    // Functions

    // Logic to get fields from stages and default to TEST/PROD fields if not found.
    // AVOID getting fields directly from TEST/PROD.
    // Other functions call this getter if fields need to be modified before they are used.
    // i.e. getClientId(), getOauth2Endpoint(), getServiceEndpoint(), etc...
    // These functions should be used instead of getField if they exist.
    function getField(stage, field) {
        var prodStages = PROD.stages;
        var testStages = TEST.stages;

        // prod
        if (prodStages.hasOwnProperty(stage)) {
            // the stage can either be a String or an Object
            if (typeof prodStages[stage] === 'string' && field === CLIENT_ID) {
                return prodStages[stage];
            } else if (prodStages[stage].hasOwnProperty(field)) {
                return prodStages[stage][field];
            } else if (PROD.hasOwnProperty(field)) {
                return PROD[field];
            }
            // test
        } else if (testStages.hasOwnProperty(stage)) {
            if (testStages[stage].hasOwnProperty(field)) {
                return testStages[stage][field];
            } else if (TEST.hasOwnProperty(field)) {
                return TEST[field];
            }
        }

        // default to prod (should never reach this point, but better safe than sorry)
        return PROD[field];
    }

    function getClientId(stage) {
        return encodeURIComponent(getField(stage, CLIENT_ID));
    }

    function getOrganization(_window, stage) {
        _window = (typeof _window === "undefined") ? window : _window;
        if (TLD_REGEX.test(_window.location.href)) {
            if (stage === 'beta') {
                return _window.location.host.split('.')[0] + '.gamma';
            } else {
                return _window.location.host.split('.')[0];
            }
        } else if (TEST.regex.test(_window.location.host)) {
            return DEFAULT_DEV_ORG;
        } else {
            return null;
        }
    }

    function getWebEndpoint(stage, _window) {
        var splitChar = '#';
        _window = (typeof _window === "undefined") ? window : _window;
        if (TLD_REGEX.test(_window.location.href)) {
            return _window.location.protocol + '//' + getOrganization(_window, stage) + '.awsapps.com/' + getField(stage, CF_ALIAS);
        } else {
            return _window.location.href.split(splitChar)[0];
        }
    }

    function getFeedbackUrl(stage) {
        var org = getOrganization(window, stage);
        // For preview site, the feedback link should point to tt quick link.
        // for other cases, it will point to the existing qualtrics link.
        if(org === AMAZON_ORG_NAME) {
            return "https://itportal-tcp.corp.amazon.com/";
        } else {
            return 'https://aws.asia.qualtrics.com/SE/?SID=SV_8I03Vr6nEKrxjXT';
        }
    }

    function getReportBugUrl(stage) {
        // For preview site, the feedback link should point to tt quick link.
        // for other cases, it will point to the existing qualtrics link.
        if(stage !== "us-west-2-prod-beta")
        {
            return 'https://t.corp.amazon.com/create/quicklink/Q000809197';
        }
        else
        {
            // Preview site
            return 'https://t.corp.amazon.com/create/quicklink/Q000834662';
        }
    }

    function isAmazonSite(stage){
        var org = getOrganization(window, stage);
        return org === AMAZON_ORG_NAME;
    }

    function getLogoClass(stage)
    {
        // For preview site, the feedback link should point to tt quick link.
        // for other cases, it will point to the existing qualtrics link.
        if(stage !== "us-west-2-prod-beta") {
            //Always change the following dummy param every time we update the logo. Otherwise Cloudfront will cache the URLs
            return 'prod-logo';
        } else {
            return 'preview-logo';
        }
    }

    function getOauth2Endpoint(stage, _window) {
        return getField(stage, LOGIN_ENDPOINT).replace(orgPlaceholder, getOrganization(_window, stage));
    }

    function getLoginV2Endpoint(stage, _window) {
        return getField(stage, LOGIN_V2_ENDPOINT).replace(orgPlaceholder, getOrganization(_window, stage));
    }

    function getServiceEndpoint(stage, isNewAPI) {
        return getField(stage, isNewAPI ? WD_SERVICE_ENDPOINT : SERVICE_ENDPOINT).replace(regionPlaceholder, stage);
    }

    function getWopiServiceEndpoint(stage) {
        return getField(stage, WOPI_SERVICE_ENDPOINT);
    }

    function getWdCollabServiceEndpoint(stage) {
        return getField(stage, COLLAB_SERVICE_ENDPOINT);
    }

    function getHancomEndpoint(stage) {
        return getField(stage, HANCOM_ENDPOINT);
    }

    function getPrintContainerUrl(stage) {
        return getField(stage, PRINT_CONTAINER_URL);
    }

    function getOauth2CallbackEndpoint(stage, _window) {
        var webEndpoint = getWebEndpoint(stage, _window);
        var flightNum = getFlightNumber();
        if (stage === 'us-west-2' && flightNum) {
            webEndpoint = webEndpoint.replace("/workdocs", "/workdocs-flight" + flightNum);
        }

        return webEndpoint + '#' + CALLBACK_PATH;
    }

    function getAppPrefix(stage, _window) {
        var appPrefix = '';

        _window = (typeof _window === "undefined") ? window : _window;
        if (TLD_REGEX.test(_window.location.href)) {
            appPrefix = getField(stage, CF_ALIAS);
        }
        var flightNum = getFlightNumber();

        //Can't use AppConstants here because this is pre-angular stuff
        if (stage === 'us-west-2' && flightNum) {
            appPrefix = appPrefix.replace("/workdocs/", "/workdocs-flight" + flightNum + "/");
        }
        if(isPreviewSite()) {
            appPrefix = appPrefix.replace("/workdocs/", "/workdocs-beta/");
        }
        return appPrefix;
    }

    function getStageConfigKey(region, /* optional mock */ _window) {
        _window = (typeof _window === "undefined") ? window : _window;
        var absUrl = _window.location.href;
        var stageConfigKey = 'dev';

        // loop through all stages in PROD
        for (var nextStage in PROD.stages) {
            if (region === nextStage && getField(nextStage, REGEX).test(absUrl)) {
                return nextStage;
            }
        }

        // loop through all stages in TEST
        for (nextStage in TEST.stages) {
            if (region === 'us-east-1' && getField(nextStage, REGEX).test(absUrl)) {
                return nextStage;
            }
        }

        // fall through to dev
        return stageConfigKey;
    }

    /*
     * Function to get the stage as ALPHA/BETA/GAMMA/PROD
     * based on the URL and the region.
     * TODO The logic in this method is very similar to
     * getStageConfigKey method above. However, we cannot
     * coalesce them because the getStageConfigKey returns
     * the stage for non-prod stages and region for prod
     * Coalesce/revisit the logic used for the two methods
     */
    function getStage(region) {
        // default stage set to alpha
        var stage = "ALPHA";
        var absUrl = window.location.href;
        // loop through all stages in PROD
        for (var nextStage in PROD.stages) {
            if (region === nextStage && getField(nextStage, REGEX).test(absUrl)) {
                return "PROD";
            }
        }

        // loop through all stages in TEST
        for (nextStage in TEST.stages) {
            if (region === 'us-east-1' && getField(nextStage, REGEX).test(absUrl)) {
                return nextStage.toUpperCase();
            }
        }

        // fall through to ALPHA
        return stage;

    }

    // Helpers
    function getRegion() {
        // CAUTION: Do not use this to get region, use regionService instead
        // because this will make fresh API calls everytime it gets called.
        // we set the region on the top-level window object, since
        // $RegionService makes use of it later
        window.AWSZocaloRegion  = window.RealAWSZocaloRegion = 'us-east-1';
        if (window.location.hostname.indexOf('awsapps.com') !== -1) {
            try {
                // Prod-beta the region is an artificial value defined in the stages
                // this is why we are not making an ajax call to get the region which
                // can never match the value below.
                if (isPreviewSite()) {
                    window.AWSZocaloRegion = "us-west-2-prod-beta";
                    window.RealAWSZocaloRegion = 'us-west-2';
                } else {
                    var flightNum = getFlightNumber();
                    if (flightNum) {
                        window.AWSZocaloRegion = "us-west-2-prod-flight" + flightNum;
                        window.RealAWSZocaloRegion = 'us-west-2';
                    } else {
                        var req = new XMLHttpRequest();
                        req.open('GET', '/region.json', false);
                        req.send(null);
                        window.AWSZocaloRegion = window.RealAWSZocaloRegion = req.status === 200 ? JSON.parse(req.responseText).region : null;
                    }
                }

            } catch(err) {

                // Do nothing, we default to IAD

            }
        }
        return window.AWSZocaloRegion;
    }

    function getOauth2RedirectUrl(stage, _window) {
        var redirectUrl = getOauth2CallbackEndpoint(stage, _window);

        var oauth2Url = getOauth2Endpoint(stage, _window) +
            '?client_id=' + getClientId(stage) +
            '&redirect_uri=' + encodeURIComponent(redirectUrl) +
            '&organization=' + getOrganization(_window, stage);

        return oauth2Url;
    }

    function getOauth2RedirectUrlBasedOnUserPreference(stage){

        var redirectUrl = getOauth2CallbackEndpoint(stage);

        if(isPreviewSite()){
            var stringToSearch = "awsapps.com" + '/workdocs-beta/',
                stringToReplace = "awsapps.com" + '/workdocs/';

            //redirect to preview site only if the user is not already on Beta.
            if (redirectUrl.indexOf(stringToSearch) === -1) {
                redirectUrl = redirectUrl.replace(stringToReplace, stringToSearch);
            }
        }

        var oauth2Url = getOauth2Endpoint(stage) +
            '?client_id=' + getClientId(stage) +
            '&redirect_uri=' + encodeURIComponent(redirectUrl) +
            '&organization=' + getOrganization(window, stage);

        return oauth2Url;
    }

    function isPreviewSite(){
        // Prod-beta the region is an artificial value defined in the stages
        // this is why we are not making an ajax call to get the region which
        // can never match the value below.
        if(window.location.href.indexOf("/workdocs-beta/") !== -1) {
            return true;
        }
        return false;
    }

    function getFlightNumber() {
        var pathname = window.location.pathname;
        var flightsRegExp = /^\/workdocs\-flight(\d)\//;
        if (flightsRegExp.test(pathname)) {
            //convert to Number data type
            return +(pathname.match(flightsRegExp)[1]);
        }
    }

    function isAllowedStage(){
        var region = window.AWSZocaloRegion || getRegion(),
            stage = getStage(region),
            isPreview = isPreviewSite(),
            isAlpha = stage === 'ALPHA',
            isGamma = stage === 'GAMMA',
            isDev = stage === 'DEV';

        if(isPreview || isAlpha || isGamma || isDev) {
            return true;
        }

        return false;
     }


    // exported interface
    return {

        // Fields
        CF_ALIAS: CF_ALIAS,
        REGEX: REGEX,
        CLIENT_ID: CLIENT_ID,
        LOGIN_ENDPOINT: LOGIN_ENDPOINT,
        LOGIN_V2_ENDPOINT: LOGIN_V2_ENDPOINT,
        SERVICE_ENDPOINT: SERVICE_ENDPOINT,
        CLIENT_ENDPOINT: CLIENT_ENDPOINT,
        DEV_ENVIRONMENT_PREFIXES: DEV_ENVIRONMENT_PREFIXES,
        METRICS_REGION_WHITELIST: METRICS_REGION_WHITELIST,

        // Functions
        getField: getField,
        getFlightNumber: getFlightNumber,
        getClientId: getClientId,
        getOrganization: getOrganization,
        getWebEndpoint: getWebEndpoint,
        getOauth2Endpoint: getOauth2Endpoint,
        getAppPrefix: getAppPrefix,
        getLoginV2Endpoint: getLoginV2Endpoint,
        getServiceEndpoint: getServiceEndpoint,
        getPrintContainerUrl: getPrintContainerUrl,
        getWopiServiceEndpoint: getWopiServiceEndpoint,
        getWdCollabServiceEndpoint: getWdCollabServiceEndpoint,
        getHancomEndpoint: getHancomEndpoint,
        getOauth2CallbackEndpoint: getOauth2CallbackEndpoint,
        getStage: getStage,
        getStageConfigKey: getStageConfigKey,
        getFeedbackUrl: getFeedbackUrl,
        getLogoClass: getLogoClass,
        getReportBugUrl: getReportBugUrl,
        isAmazonSite: isAmazonSite,

        // Helpers
        getRegion: getRegion,
        getOauth2RedirectUrl: getOauth2RedirectUrl,
        getOauth2RedirectUrlBasedOnUserPreference: getOauth2RedirectUrlBasedOnUserPreference,
        isPreviewSite: isPreviewSite,
        isAllowedStage: isAllowedStage
    };

}());
